import cfetch from 'cross-fetch'
import { 
    REST_API,
    SET_LIST_COUNT,
    SET_CURRENT_LIST_PAGE,
    SET_ITEMS_PER_PAGE
} from './constants'

import { fetchEndpointIfNeeded } from './fetch'

export function getEndpointCount( id, endpoint, token, queryStr = '' ){
    return dispatch => {
        return cfetch(`${REST_API}/${endpoint}/count?${queryStr}&access_token=${token}`)
        .then( response => {
            let json = response.json().then( json => {
                dispatch(setListCount(id, json.count))

                return json
            })

            return {
                response: response,
                json: json
            }
        })
    }
}

export function setListCount(id, count){
    return {
        type: SET_LIST_COUNT,
        count,
        id
    }
}

export function setCurrentListPage(id, page){
    return (dispatch, getState) => {
        dispatch({
            type: SET_CURRENT_LIST_PAGE,
            id,
            page
        })

        let state = getState()
        let endpoint = state.endpoints.find(
            endpoint => endpoint.id === id
        )
        
        if(endpoint.apiPaged){
            dispatch(fetchEndpointIfNeeded(id, true))
        }
    }
}


export function setItemsPerPage(id, itemsPerPage){
    return (dispatch, getState) => {
        dispatch({
            type: SET_ITEMS_PER_PAGE,
            itemsPerPage,
            id
        })

        let state = getState()
        let endpoint = state.endpoints.find(
            endpoint => endpoint.id === id
        )
        
        if(endpoint.apiPaged){
            dispatch(fetchEndpointIfNeeded(id, true))
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/pages.js